import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FaAngleRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Meta } from '../components';
import { saveShippingAddress } from '../redux/actions/cartActions';
import BreadCrumb from '../ScreenComponents/ShearCompo/BreadCrumb/BreadCrumb';
import './Css/ShippingScreen.scss';

const CheckoutScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const { user } = useSelector(state => state.userLogin);
  const [shippingAddress, setShippingAddress] = useState({
    name: cart?.shippingAddress?.name || '',
    phone: cart?.shippingAddress?.phone || '',
    email: user?.email || '',
    address: cart?.shippingAddress?.address || '',
    postcode: cart?.shippingAddress?.postcode || '',
    city: cart?.shippingAddress?.city || '',
    country: cart?.shippingAddress?.country || 'Bangladesh',
  });
  console.log(shippingAddress);
  // useEffect(() => {
  //   if (!user) {
  //     navigate('/login');
  //   }
  // }, [user, navigate]);

  const onChange = e =>
    setShippingAddress({ ...shippingAddress, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    if (
      shippingAddress.name === '' ||
      shippingAddress.division === '' ||
      shippingAddress.district === '' ||
      shippingAddress.email === '' ||
      shippingAddress.flat === '' ||
      shippingAddress.house === '' ||
      shippingAddress.note === '' ||
      shippingAddress.street === '' ||
      shippingAddress.address === '' ||
      shippingAddress.postcode === '' ||
      shippingAddress.city === '' ||
      shippingAddress.country === ''
    ) {
      toast.error('Please fill all fields');
      return;
    }
    dispatch(saveShippingAddress(shippingAddress));
    navigate('/payment');
  };

  const stagger = {
    hidden: { opacity: 0, y: 5 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.3,
        duration: 0.3,
      },
    },
  };

  return (
    <motion.div
      exit={{ opacity: 0, y: 5 }}
      variants={stagger}
      initial='hidden'
      animate='visible'
      id="checkout_main"
    >
      <Meta title={'Checkout __bubu Shopkpr'} />
      <BreadCrumb title={<span className=" d-flex items-end h-auto">
        <Link className="link" to='/'>Home</Link>
        <div className="d-flex items-center">
          <FaAngleRight />
          <span className="notLink">Checkout</span>
        </div>
      </span>} />
      <div className='checkoutHeader'>
        <p>Returning Customer? <Link to="login">Click hear to login</Link></p>
        <p>Have a coupon? <Link to="/coupon">Click hear to enter your coupon code</Link></p>
      </div>
      <Form {...{ onSubmit }}>
        <div className="row p-0 m-0">
          <div className='checkout_from col-lg-6 col-xl-6 p-0'>
            <Form.Group className="mb-3">
              <Form.Label className='d-flex items-center'>Name
                <div className='d-flex flex-column justify-center items-center'>
                  <span>*</span><span>_</span>
                </div>
              </Form.Label>
              <Form.Control type="text" placeholder="John Doe" name='name' value={shippingAddress.name} {...{ onChange }} />
            </Form.Group>
            <div className='row'>
              <div className='col-md-6 col-lg-4'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>Flat/Apartment
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="text" placeholder="flat/apartment" />
                </Form.Group>
              </div>
              <div className='col-md-6 col-lg-4'>
                <Form.Group className="mb-3" >
                  <Form.Label className='d-flex items-center'>House No
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="text" placeholder="house no" />
                </Form.Group>
              </div>
              <div className='col-md-6 col-lg-4'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>Street Number
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="text" placeholder="street num" />
                </Form.Group>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 col-lg-6'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>District
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="text" placeholder="Bogura" />
                </Form.Group>
              </div>
              <div className='col-md-6 col-lg-6'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>Division
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="text" placeholder="Rajshahi" />
                </Form.Group>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 col-lg-6'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>Phone No
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="tel" placeholder="01XXXXXXXXXX" />
                </Form.Group>
              </div>
              <div className='col-md-6 col-lg-6'>
                <Form.Group className="mb-3">
                  <Form.Label className='d-flex items-center'>Email
                    <div className='d-flex flex-column justify-center items-center'>
                      <span>*</span><span>_</span>
                    </div>
                  </Form.Label>
                  <Form.Control type="email" placeholder="info@gmail.com" />
                </Form.Group>
              </div>
            </div>
            <div className='shipping_details my-4 d-flex items-center justify-between'>
              <p>Shipping details</p>
              <Form.Group>
                <Form.Check className='d-flex items-center' type="checkbox" label="Check me out" />
              </Form.Group>
            </div>
            <Form.Group className="mb-3 w-100">
              <Form.Label className='d-flex items-center'>Special Note</Form.Label>
              <Form as="textarea" placeholder="Leave a comment here" />
            </Form.Group>
          </div>
          <div className='col-lg-6 col-xl-5 offset-xl-1'>
            <div className='shipping_details_from px-5 lg:px-0 bg-light'>
              <div className='order_details'>
                <h2 className='title'>Order Details</h2>
                <div className='detailsTitle d-flex items-center justify-between'>
                  <span className='common small' />
                  <p>Product</p>
                  <span className='common big' />
                  <p>Qty</p>
                  <span className='common small' />
                  <p>Subtotal</p>
                  <span className='common small' />
                </div>
                <div className='productDetails d-flex justify-around'>
                  <Link to="/">Plain White T-shirt - Sk 1645665</Link>
                  <strong>x100</strong>
                  <span>৳ 45000.00</span>
                </div>
                <div className='productDetails shipping_details_common d-flex justify-between px-4'>
                  <Link to="/">Subtotal</Link>
                  <span>৳ 45000.00</span>
                </div>
                <div className='productDetails shipping_details_common d-flex justify-between px-4'>
                  <Link to="/">Shipping</Link>
                  <span>Flat Rate ৳ 45000.00</span>
                </div>
                <div className='total d-flex justify-between px-4'>
                  <p>Total</p>
                  <p>৳ 45045.00</p>
                </div>
              </div>
              <div className='payments'>
                <h2 className='title'>Payments</h2>
                <div className="deliverMethod">
                  <Form.Group className='d-flex items-center'>
                    <Form.Check className='d-flex items-center' type="checkbox" />
                    <div className='methodInfo'>
                      <p>Cash on delivery</p>
                      <span>Pay with cash upon delivery.</span>
                    </div>
                  </Form.Group>
                </div>
                <div className="deliverMethod bKash">
                  <Form.Group className='d-flex items-center'>
                    <Form.Check className='d-flex items-center' type="checkbox" />
                    <div className='methodInfo'>
                      <p>bKash</p>
                      <span>Pre-pay with bKash. Redirects to payment gateway</span>
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className='agreements_submit'>
                <div className="agreements">
                  <Form.Group className='d-flex items-center'>
                    <Form.Check className='d-flex items-center' type="checkbox" />
                    <Link to="/">i have read and agree to the website terms and conditions</Link>
                  </Form.Group>
                </div>
                <Button variant="primary" onClick={onSubmit}>Place Order</Button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </motion.div >
  );
};

export default CheckoutScreen;
